export const AYS_CODE_DRG_INEK_TOP_SECTIONS = [
  'STAFF',
  'DRUGS',
  'IMPLANTS',
  'MEDICAL_SUPPLIES',
  'INFRASTRUCTURE',
];

export const AYS_CODE_DRG_INEK_SECTIONS = [
    'MEDICAL_SERVICE',
    'NURSING_SERVICE',
    'MEDTECH_SERVICE',
    'DRUGS_OVERHEAD',
    'DRUGS_SINGLE',
    'IMPLANTS',
    'MEDICAL_SUPPLIES_OVERHEAD',
    'MEDICAL_SUPPLIES_SINGLE',
    'MEDICAL_SUPPLIES_EXTERNAL',
    'INFRASTRUCTURE_MEDICAL',
    'INFRASTRUCTURE_NON_MEDICAL'
];

export const AYS_CODE_DRG_INEK_TOP_SECTION_DISPLAY_NAMES = {
  'STAFF': 'Personal',
  'DRUGS': 'Arzneimittel',
  'IMPLANTS': 'Implantate',
  'MEDICAL_SUPPLIES': 'Med. Bedarf',
  'INFRASTRUCTURE': 'Infrastruktur',
};

export const AYS_CODE_DRG_INEK_SECTION_DISPLAY_NAMES = {
    'MEDICAL_SERVICE': 'Personalkosten Ärztlicher Dienst',
    'NURSING_SERVICE': 'Personalkosten Pflegedienst',
    'MEDTECH_SERVICE': 'Personalkosten Med. tech. Dienst',
    'DRUGS_OVERHEAD': 'Arzneimittel Gemeinkosten',
    'DRUGS_SINGLE': 'Arzneimittel Einzelkosten',
    'IMPLANTS': 'Implantate / Transplantate',
    'MEDICAL_SUPPLIES_OVERHEAD': 'Med. Bedarf Gemeinkosten',
    'MEDICAL_SUPPLIES_SINGLE': 'Med. Bedarf Einzelkosten',
    'MEDICAL_SUPPLIES_EXTERNAL': 'Med. Bedarf Ext. Behandlungsleistunge',
    'INFRASTRUCTURE_MEDICAL': 'Infrastruktur med.',
    'INFRASTRUCTURE_NON_MEDICAL': 'Infrastruktur nicht med.'
};
